import { AlertTriangle, ShoppingBag } from "lucide-react";
import { BUDGET_CAP } from "@/lib/constants";

export const BudgetBar = ({ total, count, onOpenCart }) => {
  const pct = Math.min(100, Math.round((total / BUDGET_CAP) * 100));
  const remaining = Math.max(0, BUDGET_CAP - total);
  const over = total > BUDGET_CAP;

  return (
    <div
      data-testid="budget-bar"
      className="fixed inset-x-0 bottom-0 z-40 border-t-2 border-black bg-white"
    >
      <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-4 py-3 md:flex-row md:items-center md:gap-6 md:px-10 md:py-4">
        <div className="flex items-center justify-between gap-4 md:flex-1">
          <div className="flex items-center gap-3">
            <div
              className={`h-3 w-3 ${
                over ? "bg-[#EF4444]" : "bg-[#9D4CDD]"
              } hg-pulse`}
            />
            <div>
              <div
                data-testid="budget-total-label"
                className="font-display text-[10px] font-bold uppercase tracking-[0.25em] text-black/60"
              >
                Your total · {count} {count === 1 ? "item" : "items"}
              </div>
              <div className="flex items-baseline gap-2">
                <span
                  data-testid="budget-total-amount"
                  className={`font-display text-2xl font-black tracking-tight md:text-3xl ${
                    over ? "text-[#EF4444]" : "text-black"
                  }`}
                >
                  £{total.toLocaleString()}
                </span>
                <span className="font-display text-sm text-black/50">
                  / £{BUDGET_CAP.toLocaleString()}
                </span>
              </div>
            </div>
          </div>

          <div className="hidden text-right md:block">
            <div className="font-display text-[10px] font-bold uppercase tracking-[0.25em] text-black/60">
              {over ? "Over budget" : "Remaining"}
            </div>
            <div
              data-testid="budget-remaining"
              className={`font-display text-xl font-black tracking-tight md:text-2xl ${
                over ? "text-[#EF4444]" : "text-[#9D4CDD]"
              }`}
            >
              {over ? `-£${(total - BUDGET_CAP).toLocaleString()}` : `£${remaining.toLocaleString()}`}
            </div>
          </div>
        </div>

        {/* Progress bar */}
        <div className="md:flex-[1.2]">
          <div className="relative h-3 w-full border-2 border-black bg-white">
            <div
              data-testid="budget-progress-fill"
              className={`hg-progress-fill h-full ${
                over ? "bg-[#EF4444]" : "bg-[#9D4CDD]"
              }`}
              style={{ width: `${pct}%` }}
            />
          </div>
          <div className="mt-1 flex items-center justify-between">
            <span className="font-display text-[10px] font-bold uppercase tracking-[0.2em] text-black/50">
              {pct}% of budget
            </span>
            {over && (
              <span className="inline-flex items-center gap-1 font-display text-[10px] font-bold uppercase tracking-[0.2em] text-[#EF4444]">
                <AlertTriangle className="h-3 w-3" strokeWidth={3} />
                Remove items to submit
              </span>
            )}
          </div>
        </div>

        <button
          type="button"
          data-testid="budget-cta-checkout"
          onClick={onOpenCart}
          disabled={count === 0}
          className={`inline-flex items-center justify-center gap-2 border-2 px-5 py-3 font-display text-xs font-bold uppercase tracking-[0.2em] transition-all md:py-4 ${
            count === 0
              ? "border-black/20 bg-black/10 text-black/30 cursor-not-allowed"
              : "border-black bg-black text-white hover:bg-[#9D4CDD] hover:border-[#9D4CDD]"
          }`}
        >
          <ShoppingBag className="h-4 w-4" />
          Review & submit
        </button>
      </div>
    </div>
  );
};
